<script>
import resources from './resources'

export default {
  name: 'items',
  mixins: [resources]
}
</script>

<template lang="pug">
      tbody
        tr
          td.data {{ item.date }}
          td 08:00
          td 08:30
          td 09:30
</template>



// WEBPACK FOOTER //
// src/app/patient/loading-page/components/Items/items.vue